import type { UseQueryOptions } from 'react-query';
import { useGetApi } from '@hooks/api/useGetApi';
import {
  organizationSiteApiKeys,
  useOrganizationSiteApi,
} from '@hooks/api/useOrganizationSiteApi';
import type { OrganizationSiteProfileResponse } from 'types/organization-site';

export function useGetSiteProfile(
  organizationId: string,
  type: keyof OrganizationSiteProfileResponse = 'preview',
  options?: UseQueryOptions<OrganizationSiteProfileResponse>
) {
  const api = useOrganizationSiteApi();

  const result = useGetApi({
    enabled: !!organizationId,
    queryKey: organizationSiteApiKeys.get(organizationId),
    request: () => api.get(organizationId),
    ...options,
  });

  return {
    ...result,
    siteProfile: result.data?.[type],
  };
}
